import type { FixedIconProps } from '../../../../../../mads/icons/Icon';
import type { ComponentType } from 'react';
import type { ColorValue } from 'react-native';

import { Box, Flex, Text } from '../../../../../../mads';

import { colors, spacing } from '@indeed/ifl-tokens/react-native';

type ProInsightsDataLineProps = {
    icon: ComponentType<FixedIconProps>;
    iconColor?: ColorValue;
    headingText: string;
    descriptions: string[];
};

export function ProInsightsDataLine(props: ProInsightsDataLineProps): React.JSX.Element {
    return (
        <Flex sx={{ flexDirection: 'row', gap: spacing.s2, marginBlockStart: spacing.s2 }}>
            <props.icon aria-hidden size="sm" color={props.iconColor} />
            <Box sx={{ flex: 1 }}>
                <Text level={2} variant="contrast" sx={{ fontWeight: 'bold' }}>
                    {props.headingText}
                </Text>
                {props.descriptions?.map(
                    (desc, index) =>
                        !!desc && (
                            <Text level={1} sx={{ color: colors.foregroundWeak }} key={index}>
                                {desc}
                            </Text>
                        ),
                )}
            </Box>
        </Flex>
    );
}
